// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatbotHeader_wrapper__Ju_Cm","close":"ChatbotHeader_close__4u0LN","scrolled":"ChatbotHeader_scrolled__s94uY"};